<template>
    <div id="modal-contract-period-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="mb-2 d-flex">
                        <div class="pt-2 text-nowrap">契約開始&nbsp;&nbsp;</div>
                        <div class="d-flex">
                            <select class="form-control px-1" v-model="startMonth" @change="changeStartMonth">
                                <option value="0">--選択--</option>
                                <option v-for="(op,index) in startMonthList" :value='op' :key="index">{{op | dformatym}}</option>
                            </select>
                            <span class="pt-2">&nbsp;月&nbsp;</span>
                        </div>
                        <div class="d-flex">
                            <select class="form-control px-2" v-model="startDay">
                                <option value="0">--選択--</option>
                                <option v-for="(n,index) in startMonthdays" :key="index" :value="addZero(n)">{{addZero(n)}}</option>
                            </select>
                            <span class="pt-2">&nbsp;日&nbsp;</span>
                        </div>
                    </div>
                    <div class="mb-2 d-flex">
                        <div class="pt-2 text-nowrap">契約終了&nbsp;&nbsp;</div>
                        <div class="d-flex">
                            <select class="form-control px-1" v-model="endMonth" @change="changeEndMonth">
                                <option value="0">--選択--</option>
                                <option v-for="(op,index) in endMonthList" :value='op' :key="index">{{op | dformatym}}</option>
                            </select>
                            <span class="pt-2">&nbsp;月&nbsp;</span>
                        </div>
                        <div class="d-flex">
                            <select class="form-control px-2" v-model="endDay">
                                <option value="0">--選択--</option>
                                <option v-for="(n,index) in endMonthdays" :key="index" :value="addZero(n)">{{addZero(n)}}</option>
                            </select>
                            <span class="pt-2">&nbsp;日&nbsp;</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="contractPeriodSave" :disabled="isDisableBtn">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    props: {
        opt: String
    },
    data () {
        return {
            startMonthList: [],
            endMonthList: [],
            startMonth: '0',
            startDay: '0',
            endMonth: '0',
            endDay: '0',
            intvId: "",
            userId: "",
            inD: "",
        }
    },
    mounted () {
        this.makeMonthList();
    },
    watch: {
        getContractPeriodSaveStatus (status) {
            if (status == '1') {
                this.$store.dispatch('startProgress')
            }
            if (status == '2') {
                this.hideThis()
                this.$store.dispatch('doneProgress')
            }
            if (status == '3') {
                this.$store.dispatch('startProgress')
            }
        }
    },
    computed: {
        isDisableBtn () {
            if (this.startMonth == '0' || this.endMonth == '0') {
                return true
            }
            let start = this.startMonth + '-' + this.addZero(this.startDay)
            let end = this.endMonth + '-' + this.addZero(this.endDay)
            let startDate = this.$moment(start)
            let endDate = this.$moment(end)
            if (startDate.diff(endDate,'days') > 0) {
                return true
            }
            return false
        },
        startMonthdays () {
            if (this.startMonth != '0') {
                return this.$moment(this.startMonth).daysInMonth()
            }
            return 0
        },
        endMonthdays () {
            if (this.endMonth != '0') {
                return this.$moment(this.endMonth).daysInMonth()
            }
            return 0
        },
        ...mapGetters(['getContractPeriodSaveStatus'])
    },
    methods: {
        openThis (item) {
            this.startMonth = item.start_month ? item.start_month : '0'
            this.startDay = item.start_day ? item.start_day : '0'
            this.endMonth = item.end_month ? item.end_month : '0'
            this.endDay = item.end_day ? item.end_day : '0'
            this.intvId = item.id
            this.userId = item.user_id
            this.inD = item.in_d

            if (!this.startMonthList.includes(this.startMonth) && this.startMonth != '0') {
               this.startMonthList.unshift(this.startMonth)
            }
            if (!this.endMonthList.includes(this.endMonth) && this.endMonth != '0') {
               this.endMonthList.unshift(this.endMonth)
            }

            $('#modal-contract-period-set').modal('show')
        },
        hideThis () {
            this.resetThis()
            $('#modal-contract-period-set').modal('hide')
        },
        resetThis () {
            this.startMonth = '0'
            this.startDay = '0'
            this.endMonth = '0'
            this.endDay = '0'
            this.intvId = ""
            this.userId = ""
            this.inD = ""
        },
        contractPeriodSave () {
            this.$store.dispatch('contractPeriodSave', {
                inD: this.inD, // 画面更新用
                opt: this.opt,
                intvId: this.intvId,
                userId: this.userId,
                startMonth: this.startMonth,
                startDay: this.startDay,
                endMonth: this.endMonth,
                endDay: this.endDay
            })
        },
        makeMonthList () {
            for (let i=0; i < 12; i++) {
                this.startMonthList.push(this.$moment(new Date).add(i,'months').format('YYYY-MM'))
            }
            for (let i=0; i < 24; i++) {
                this.endMonthList.push(this.$moment(new Date).add(i,'months').format('YYYY-MM'))
            }
        },
        addZero (data) {
            return ('00' + data).slice(-2)
        },
        changeStartMonth () {
            if (this.startMonth == '0') {
                this.startDay = '0'
            } else {
                this.startDay = '01'
            }
        },
        changeEndMonth (val) {
            if (this.endMonth == '0') {
                this.endDay = '0'
            } else {
                this.endDay = this.$moment(this.endMonth).daysInMonth()
            }
        },
    }
}
</script>

<style>

</style>
